import { createContext } from 'react';
import realPropertyAppealInitialValues from 'src/data/formDataInitialValues/realPropertyAppeal';
import useForm from 'src/services/useForm';

const FormContext = createContext();

export const RealPropertyAppealFormProvider = ({ children }) => {
  const value = useForm({
    apiPath: '/real-property-appeal',
    createFormData: (data) => {
      const formData = {};
      for (const key in data) {
        formData[key] = JSON.stringify(data?.[key]);
      }
      return formData;
    },
    // Real Property appeals are handled by the Treasurer's Office; keep these in sync with
    // the contacts in server/appeal/real-property-appeal.js.
    contacts: [
      { name: 'Troy Worthen', email: 'troyw@utahcounty.gov', phone: '(801) 851-8266' },
      { name: 'Jeanne Bowen', email: 'jeanneb@utahcounty.gov', phone: '(801) 851-8256' },
    ],
    initialValues: realPropertyAppealInitialValues,
    pageTitle: 'Real Property Appeal Form',
  });

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export default FormContext;
